export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    userData() {
      return JSON.parse(localStorage.getItem("userData"));
    },
  },
  render(h) {
    const span = h("span", {}, this.item.header);
    const div = h("div", { class: "navigation-header-line" });
    const icon = h("feather-icon", {
      props: { icon: "MoreHorizontalIcon", size: "18" },
    });
    if (
      this.item.accountTypes &&
      this.item.accountTypes.includes(this.userData.type)
    )
      return h("li", { class: "navigation-header text-truncate" }, [
        span,
        icon,
        div,
      ]);
  },
};
